@if (useFastIconType) {
    <vn-menu-item
        class="bottom-sheet-item"
        [item]="item"
        [section]="MenuSection.BottomSheet"
        [displayMode]="MenuDisplayMode.FastIcon"
        badgePosition="FastIcon"
        (onClick)="close()"
        linkClass="btn" />
} @else {
    <vn-menu-item class="bottom-sheet-item" [item]="item" [section]="MenuSection.BottomSheet" (onClick)="close()" linkClass="btn" />
}
